import { useEffect, useSyncExternalStore } from 'react'
import { get, post } from 'src/functions/fetch'
import config from 'src/config'
import Build from 'src/layout/Navigation/build.preval'
import { createNavigationCache } from './navigationCache'
import { scheduleNavigationImageWarmup } from './Navigation/navigationImages'

// Created once for this shop's bundle. All consumers see the same instant
// snapshot and share one background version check, including repeated opens.
const navigation = createNavigationCache({
  scope: {
    menuId: process.env.NEXT_PUBLIC_MENU || 'default',
    shopId: String(config.shop.shop),
    language: String(config.shop.lang || 'de'),
    buildDate: Build.buildDate,
  },
  initialPaths: Build.paths,
  getVersion: signal => get({ url: `menuTree/${process.env.NEXT_PUBLIC_MENU}`, signal }),
  getPaths: signal => post({ url: `menuTree/${process.env.NEXT_PUBLIC_MENU}`, body: config.shop, signal }),
  storage: () => typeof window !== 'undefined' ? window.sessionStorage : undefined,
})

const useNavigationPaths = () => {
  const paths = useSyncExternalStore(navigation.subscribe, navigation.getSnapshot, navigation.getServerSnapshot)
  useEffect(() => { void navigation.refresh() }, [])
  useEffect(() => {
    if (config.mobileMenuVariant === 'modern') scheduleNavigationImageWarmup(paths)
  }, [paths])
  return paths
}

export default useNavigationPaths
